export enum TypeEntiteEnum {
  PARTENAIRE = "Partenaire",
  FOURNISSEUR = "Fournisseur",
  ENTREPRISE = "Entreprise",
  UTILISATEUR = "Utilisateur",
}